import React, { useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { AuthContext } from 'src/context/ute-auth-context/auth-provider';
import { AURegistrationStatus, AUVerificationStatusResponse } from 'src/modules/common/common-types';
import LoginLayout from 'src/modules/layout/login-layout';
import ThirdPartyLoginComponent from 'src/modules/third-party-login';
import {
	isAccessLinkExpired,
	isThirdPartyUserVerified,
	validateOTPForAULogin,
	validateOTPForAURegistration,
} from 'src/modules/third-party-login/third-party-login-component-api';
import LoadingOverlay from 'react-loading-overlay';
import Loader from 'src/components/loader';
import { useDeviceType } from 'src/hooks/useDeviceType';

const ThirdPartyLoginContainer: React.FC = () => {
	const deviceType = useDeviceType();
	const { companyId } = useContext(AuthContext);
	const navigate = useNavigate();
	const [isVerificationComplete, setIsVerificationComplete] = useState(false);
	const auClientGuid = useParams().auClientGuid ?? '';
	const [component, setComponent] = useState('');

	useEffect(() => {
		if (component === 'access-verify') {
			isThirdPartyUserVerified(
				companyId,
				auClientGuid,
				(auVerificationStatusResponse: AUVerificationStatusResponse) => {
					if (auVerificationStatusResponse.status === AURegistrationStatus.Verified) {
						navigate(
							`/third-party/access-verified?clientName=${encodeURIComponent(
								auVerificationStatusResponse.clientName,
							)}&isAlreadyVerified=true&accessIdentifier=${auClientGuid}`,
						);
					}

					setIsVerificationComplete(true);
				},
			);
		}
		if (component === 'login') {
			isAccessLinkExpired(companyId, auClientGuid, () => {
				setIsVerificationComplete(true);
			});
		}
	}, [companyId, auClientGuid, navigate, component]);

	useEffect(() => {
		const pathArray = window.location.pathname.split('/');
		const clientId = pathArray[pathArray.length - 1];
		const componentName = pathArray[pathArray.length - 2];
		setComponent(componentName);
		localStorage.setItem('clientId', clientId);
	}, []);

	return (
		<>
			{!isVerificationComplete ? (
				<LoadingOverlay
					active={!isVerificationComplete}
					spinner={<Loader />}
					text=''>
					<div style={{ width: '100vw', height: '100vh' }}></div>
				</LoadingOverlay>
			) : (
				<LoginLayout>
					{component === 'login' && (
						<ThirdPartyLoginComponent
							auClientGuid={auClientGuid}
							validateOTP={validateOTPForAULogin}
							component={component}
							generateOTPSubHeaderText={
								<>
									We will send you a One-Time Access Code
									{deviceType === 'desktop' ? <br /> : ''} to your mobile number.
								</>
							}
						/>
					)}
					{component === 'access-verify' && (
						<ThirdPartyLoginComponent
							auClientGuid={auClientGuid}
							validateOTP={validateOTPForAURegistration}
							component={component}
						/>
					)}
				</LoginLayout>
			)}
		</>
	);
};

export default ThirdPartyLoginContainer;
